import { render, staticRenderFns } from "./activityMyAssessments.html?vue&type=template&id=2c88987f&scoped=true&external"
import script from "./activityMyAssessments.vue?vue&type=script&lang=js"
export * from "./activityMyAssessments.vue?vue&type=script&lang=js"
import style0 from "./activityMyAssessments.css?vue&type=style&index=0&id=2c88987f&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c88987f",
  null
  
)

export default component.exports